import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";

const POLICY = [
  { badge: "Unopened", title: "Full refund", body: "Any unopened bottle returned within 30 days of delivery is refunded in full to the original payment method." },
  { badge: "Opened", title: "Store credit", body: "Opened bottles cannot be restocked, but we’ll issue store credit within 30 days if the fragrance isn’t working on your skin." },
  { badge: "Damaged", title: "Replacement at our cost", body: "If your bottle arrives damaged, send us a photo within 7 days and we’ll ship a replacement immediately — no return required." },
  { badge: "Engraved", title: "Case-by-case", body: "Personalised or engraved bottles are final sale, but we’ll always work with you if there’s a genuine issue — email our concierge." },
];

const HOW_TO = [{
  heading: "How to initiate a return",
  body: "1. Email us with your order number and reason for return.\n\n2. We reply within 1 business day with a pre-paid return label.\n\n3. Pack the bottle in its original carton with protective wrapping.\n\n4. Drop it at any authorised courier location — we track it back to our Canadian atelier.\n\n5. Refunds process within 5 business days of receipt; store credits are issued immediately.",
}];

const EXCHANGES = [{
  heading: "Exchanges",
  body: "If a fragrance isn’t what you hoped for, we’re happy to work with you on an exchange for a different Scentodore. Email us within 30 days and we’ll walk you through it.",
}];

const FINAL_SALE = [{
  heading: "Final sale items",
  body: "10ml sample vials, gift cards, and personalised/engraved products are non-refundable except in the case of manufacturing defect or shipping damage.",
}];

const WRONG = [{
  heading: "Damaged or incorrect orders",
  body: "If we shipped the wrong item, or your bottle arrived damaged, that’s our mistake to fix. Send a photo within 7 days and we’ll re-ship the correct item at our cost.",
}];

export default function ReturnsPage() {
  return (
    <PageShell
      slug="returns"
      testid="returns"
      eyebrow="Returns & Refunds"
      title="30-day satisfaction promise."
      intro="Fragrance is deeply personal. If a Scentodore doesn’t work on your skin, we’ll make it right — full refund on unopened bottles, store credit on opened ones."
    >
      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Policy at a glance</h2>
        <EditableFeatureGrid slug="returns" sectionKey="policy" fallback={POLICY} />
      </div>
      <EditableSection slug="returns" sectionKey="how_to" fallback={HOW_TO} />
      <EditableSection slug="returns" sectionKey="exchanges" fallback={EXCHANGES} />
      <EditableSection slug="returns" sectionKey="final_sale" fallback={FINAL_SALE} />
      <EditableSection slug="returns" sectionKey="wrong" fallback={WRONG} />
    </PageShell>
  );
}
